import Header from "components/Headers/Header";
import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Bathtub from "assets/images/Bathtub.svg";
import { get } from "utils/api";
import { Spinner } from "react-bootstrap";
import { GetColorName } from "hex-color-to-color-name";


export const FurnitureDetail = () => {
   const location = useLocation();
   const { furId } = location.state || {};
   const navigate = useNavigate()
  const [furnitureDetail, setFurnitureDetail] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const fetchApi = () => {
    setIsLoading(true);
    get(`api/furniture/admin/get/${furId}`)
      .then((res) => {
        setFurnitureDetail(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (furId) {
      fetchApi();
    }
    if (!furId) {
      navigate("/");
    }
  }, [furId]);
  return (
    <>
      <Header />
      {isLoading ? (
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      ) : furnitureDetail ? (
        <>
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <div className="main-box mt-0">
                  <div className="content-header">
                    <h3>{furnitureDetail?.name.toUpperCase()}</h3>
                    {/* <a href="editprofile.html">
                Edit Profile <img src={img_editprofile} alt="Edit" />
              </a> */}
                  </div>
                  <div className="content-middle">
                    <div className="profile-sec">
                      <img
                        src={
                          furnitureDetail?.furniture_images
                            ? `${process.env.REACT_APP_BASE_URL}/${furnitureDetail?.furniture_images[0].imageUrl}`
                            : Bathtub
                        }
                        alt="Image_Not_Found"
                      />
                    </div>
                    <div className="profile-content">
                      <ul>
                        <li>
                          <span>Brand</span>
                          {furnitureDetail?.brand}
                        </li>
                        <li>
                          <span>Color</span>
                          <span
                            className="color-dot"
                            style={{ backgroundColor: furnitureDetail?.color }}
                          > </span>
                          {furnitureDetail?.color && (
                            <span className="color-name">
                              {GetColorName(furnitureDetail?.color)}
                            </span>
                          )}
                        </li>

                        <li>
                          <span>Add on</span>
                          {`${new Date(
                            furnitureDetail?.createdAt
                          ).toLocaleDateString("en-US")}`}
                        </li>
                        <li>
                          <span>Last update on</span>
                          {`${new Date(
                            furnitureDetail?.updatedAt
                          ).toLocaleDateString("en-US")}`}
                        </li>
                        <li>
                          <span>Price</span>
                          <>${furnitureDetail?.price}</>
                        </li>
                        <li>
                          <span>Material</span>
                          <>{furnitureDetail?.material}</>
                        </li>
                        <h3>Description</h3>
                        <p>
                          <>{furnitureDetail?.description}</>
                        </p>
                        {/* <li>
                <span>
                  <img src={img_location_info} alt="message" />
                  Zip Code
                </span>
                {furnitureDetail?.userAddress?.zip_code
                  ? furnitureDetail?.userAddress?.zip_code
                  : "Not Provided"}
              </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="main-box mt-4">
                  <div className="box-header">
                    <div className="dual-btn">
                      <button
                        className="navbar-toggler"
                        type="button"
                        onClick={() => {
                          window.history.back();
                        }}
                      >
                        Go Back{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <p>Data not found</p>
      )}
    </>
  );
};
